"use client";

import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { TriangleAlert } from "lucide-react";

export default function ModalConfirmationExample() {
  const [open, setOpen] = React.useState(true);
  return (
    <div className="space-y-4">
      <Button variant="destructive" onClick={() => setOpen(true)}>Open Confirmation Modal</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-6xl! w-6xl! bg-transparent shadow-none border-0 p-0">
          <div className="bg-card/95 backdrop-blur-xl rounded-xl w-full overflow-hidden shadow-2xl border border-white/10 flex flex-col">
            <div className="p-6 pb-4 border-b border-white/10 bg-gradient-to-b from-primary/5 to-transparent flex items-center gap-3">
              <TriangleAlert className="h-6 w-6 text-destructive" />
              <h2 className="text-2xl font-bold text-foreground">Delete item?</h2>
            </div>
            <div className="p-6 space-y-3">
              <p className="text-muted-foreground">This action cannot be undone. This will permanently delete the selected item and remove associated data.</p>
            </div>
            <div className="border-t border-white/10 px-6 py-4 bg-gradient-to-t from-primary/5 to-transparent flex justify-end gap-2">
              <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
              <Button variant="destructive" onClick={() => setOpen(false)}>Delete</Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
